import React from 'react';
import { Link } from '../../routing';
import './Footer.scss';
const Footer: React.FC = () => <footer className="footer"><div className="footer__container"><nav><Link to="/about">About</Link><Link to="/contact">Contact</Link><Link to="/">Home</Link></nav><p>© {new Date().getFullYear()} Stage Door Media</p></div></footer>;
export default Footer;
